import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

// --- CORRECCIÓN CRÍTICA DE IMPORTACIÓN ---
// Importamos con llaves { } porque en firebase.js usamos export const
// Importamos con llaves { } porque en firebase.js usamos export const
import { auth, db } from '../api/firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Efecto para escuchar la sesión de Firebase
  useEffect(() => {
    // Verificación de seguridad: si auth no cargó, no intentar usarlo
    if (!auth) {
      console.error("Firebase Auth no está inicializado. Revisa firebase.js");
      setLoading(false);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Usuario logueado -> Buscamos su rol
        try {
          const userDocRef = doc(db, "users", user.uid);
          const userDoc = await getDoc(userDocRef);

          let role = 'INVITADO';
          let name = user.displayName;
          if (userDoc.exists()) {
            const data = userDoc.data();
            // Soporte para campo 'role' o 'rol'
            role = data.role || data.rol || 'INVITADO';
            name = data.name || data.nombre || name;
          }

          setCurrentUser({ ...user, role, name });
        } catch (error) {
          console.error("Error obteniendo rol:", error);
          setCurrentUser(user); // Loguear igual aunque falle el rol
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    return signOut(auth);
  };

  const value = {
    currentUser,
    login,
    logout
  };

  // Pantalla de Carga (Evita pantalla blanca)
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-4 w-48 bg-slate-700 rounded mb-2"></div>
          <div className="text-sm text-slate-400">Conectando con Firebase...</div>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
